import React from "react";
import FormSelect from "Common/Custom/FormSelect";
import FormDatePicker from "Common/Custom/ReactFlatpickr";

const AttendanceDashboardForm = ({ 
    rosters, 
    activeRoster, 
    setActiveRoster, 
    date, 
    setDate 
}) => {
    return (
        <div className="row g-3 mb-4">
            <div className="col-md-6 col-lg-5">
                <FormSelect
                    field={{
                        name: "roster_select",
                        placeholder: "Select Roster",
                        fieldSize: "col-12",
                        label: "Select Roster Type"
                    }}
                    value={activeRoster || ""}
                    handleChange={(e) => setActiveRoster(e.target.value)}
                    options={rosters.map(roster => ({
                        value: roster.roster_id,
                        label: roster.roster_name
                    }))}
                />
            </div>
            <div className="col-md-6 col-lg-4">
                <FormDatePicker
                    field={{
                        name: "attendance_date",
                        label: "Select Attendance Date",
                        placeholder: "Select Date",
                        fieldSize: "col-12"
                    }}
                    value={date}
                    handleChange={(e) => setDate(e.target.value)}
                />
            </div>
        </div>
    );
};

export default AttendanceDashboardForm;
